import React from 'react';
import PropTypes from 'prop-types';
// @mui
import { DialogTitle, DialogActions, IconButton, useTheme, Drawer, Slide } from '@mui/material';
import Iconify from './Iconify';
// import { DialogAnimate, varFade } from './animate';
// utils
// import cssStyles from '../utils/cssStyles';

// ----------------------------------------------------------------------

CustomDrawer.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  open: PropTypes.bool,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  hasClose: PropTypes.bool,
  children: PropTypes.node,
  isBackdropClosable: PropTypes.bool,
  hasTransition: PropTypes.bool,
};

export default function CustomDrawer({
  children,
  title = '',
  actions,
  open,
  onClose,
  hasClose = true,
  isBackdropClosable = true,
  // hasTransition = true,
  paperPropsSx,
  ...other
}) {
  const theme = useTheme();

  const handleClose = (e, r) => {
    if (!isBackdropClosable && r === 'backdropClick') {
      return false;
    }

    if (!isBackdropClosable && r === 'escapeKeyDown') {
      return false;
    }

    onClose(e, r);
    return true;
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      {...other}
      PaperProps={{
        sx: {
          backgroundColor: '#fff',
          borderTopLeftRadius: (theme) => theme.spacing(2),
          borderTopRightRadius: (theme) => theme.spacing(2),
          ...paperPropsSx,
          // '&::-webkit-scrollbar': {
          //   display: 'none',
          // },
          // msOverflowStyle: 'none',
          // scrollbarWidth: 'none',
        },
      }}
    >
      {hasClose && (
        <IconButton
          aria-label="close"
          onClick={() => onClose()}
          color="primary"
          size="small"
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            zIndex: 1,
            color: '#353845',
          }}
        >
          <Iconify sx={{ fontSize: '24px' }} icon={'material-symbols:close-rounded'} />
        </IconButton>
      )}
      {title && (
        <DialogTitle
          sx={{
            color: '#212b36',
            fontSize: '18px',
            textAlign: 'center',
            padding: '16px 16px 0px 16px',
            fontWeight: 600,
          }}
        >
          {title}
        </DialogTitle>
      )}
      {children}
      {actions && <DialogActions>{actions}</DialogActions>}
    </Drawer>
  );
}
